<section class="about-us-section padding-bottom">
    <div class="container">
        <h2 class="section-title text-left">{{cmsName}}</h2>
        <p class="about-text-para" [innerHTML]="cmsData">
        </p>
    </div>
</section>